module.exports = __webpack_public_path__ + "static/img/egg_b_14.9571825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_14.png
// module id = aDMF
// module chunks = 1